import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, inject, ref, watch } from "vue";
import { API_BIS_PATENT_SINGLEINDEXING } from "@/configs/Apis";
import { showConfirm, showSuccess, showWarning } from "@/utils/UI";
import DuduAjax from "@/utils/DuduAjax";
import { useStore } from "@/stores";


export default /*#__PURE__*/_defineComponent({
  __name: 'PatentIndexing',
  props: {
  patent: { required: true, default: () => ({}), type: Object },
},
  emits: ["refresh-tree"],
  setup(__props, { emit }) {

const props = __props;





const instance = getCurrentInstance() as any;
const proxy = instance.proxy as any;
const store = useStore();

const customfieldValues = ref<any>({});

const projectId = computed(() => {
  const pInfo: any = (store.state as any).project.info || {};
  return pInfo.id || 0;
});

function parsePatentData() {
  const fields: Array<any> = proxy.$store.getters["project/customfields"];
  const fieldData: any = {};
  if (fields && fields.length) {
    fields.forEach((field: any) => {
      const cfield = field.fieldName.replace("_", "");
      if (field.fieldType === "TEXT") {
        fieldData[cfield] = props.patent.patentText ? props.patent.patentText[cfield] || "" : "";
      } else {
        fieldData[cfield] = props.patent[cfield] || "";
      }
    });
  }
  customfieldValues.value = fieldData;
}

function saveIndexing() {
  const customfields: Array<any> = proxy.$store.state.project.metadata;
  if (!customfields || !customfields.length) {
    showWarning("没有需要保存的自定义标引字段");
    return;
  }
  showConfirm("是否保存自定义标引的值").then(() => {
    const patent = props.patent as any;
    const postedData: Array<string[]> = [];

    customfields.forEach((field: any) => {
      const fieldName = field.fieldName.replace("_", "");
      if (Object.prototype.hasOwnProperty.call(props.patent, fieldName)) {
        postedData.push([fieldName, customfieldValues.value[fieldName]]);
      }
    });

    DuduAjax.post(
      { url: API_BIS_PATENT_SINGLEINDEXING, path: { projectId } },
      { patentId: props.patent.id, indexingInfo: postedData }
    ).then(() => {
      Object.assign(patent, customfieldValues.value);
      showSuccess("保存成功");
      emit("refresh-tree");
    });
  });
}

watch(
  () => props.patent,
  () => {
    parsePatentData();
  }
);

parsePatentData();

return { __sfc: true,props, emit, instance, proxy, store, customfieldValues, projectId, parsePatentData, saveIndexing }
}

})